import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import './style.css'
import UpdateCancel from '../../atoms/buttons/UpdateCancel.js';
import { Grid } from '@material-ui/core';
import { handleSnackBar, invokePostService, setReRender } from '../../../store/global/actions.js';
import { getDetailsFromUrl } from '../../../services/blueprint.js';


export default function TransactionSelector({ transactions, testcaseId, selectedTransactions, setSelectedTransactions, setSelectedDelegates, type, isFetching, setIsFetching, onClose }) {

    const dispatch = useDispatch();

    const [schemaValues, setSchemaValues] = useState({ simulation: [{ transaction: "select", description:" " }] });
    const { entityId } = getDetailsFromUrl()

    // For rerender the form to show selected transactions as selected
    const updateFormValues = () => {
        setIsFetching(true);
        if (selectedTransactions?.length > 0) {
            const newSchemaValues = [];
            selectedTransactions.forEach((tr) => {
                newSchemaValues.push({ transaction: tr._id, simulationTransaction: tr.simulationTransactionId, description: tr?.description !== undefined ? tr.description: "" });
            });
            setSchemaValues({ simulation: newSchemaValues });
        }
        setIsFetching(false);
    }

    useEffect(() => {
        updateFormValues();
        // For making transaction tab as selected
        const tabIndicators = document.getElementsByClassName("MuiTabs-indicator");
        if (tabIndicators) {
            tabIndicators[0].style.left = "160px";
            tabIndicators[0].style.width = "160px";
        }
    }, [transactions]);


    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    let options = {
        form_name_root: "simulation",
        show_errors: "never",
        disable_collapse: true,
        disable_edit_json: true,
        disable_properties: true,
        remove_button_labels: true,
        input_width: '100px',
        disable_array_delete_all_rows: true,
        disable_array_delete_last_row: true,
        disable_array_add: true // For hiding + button
    }

    const schema = {
        type: "object",
        no_additional_properties: true,
        properties: {
            simulation: {
                type: "array",
                format: "table",
                items: {
                    type: "object",
                    title: "Transaction",
                    properties: {
                        transaction: {
                            type: "string",
                            enumSource: [{
                                source: [{ title: "Select transaction", value: 'select' }, 
                                    ...transactions.map((transaction) => { 
                                        return { 
                                            'title': transaction.name, 
                                            'value': transaction._id 
                                        }; 
                                    })
                                ],
                                title: "{{item.title}}",
                                value: "{{item.value}}"
                            }],
                            title: "Transaction",
                        },
                        description: {
                            type: "string",
                            title: "Description",
                            default: "",
                            options: {
                                hidden: false
                            }
                        },
                        simulationTransaction: {
                            type: "string",
                            options: { hidden: true }
                        }
                    }
                }
            }
        },
        options: {
            disable_collapse: true,  // Optional to prevent collapsing sections
            disable_properties: true // Optional to prevent adding new properties
        }
    };
    

    const onChangeJsonEditor = (data) => {
        // For get the selected transactions 
        const transactionsDetails = data.simulation?.filter(tr => tr.transaction !== 'select')?.map((element, index) => {
            const transactionsCopy = JSON.parse(JSON.stringify(transactions))
            const transactionData = transactionsCopy.find(t => t._id == element.transaction);
            const obj = selectedTransactions.find(element => element.simulationTransactionId == element.simulationTransaction);
            transactionData.simulationTransactionId = element.simulationTransaction;
            transactionData.description = element.description
            return transactionData;
        });
        if (transactionsDetails?.length > 0) {
            setSelectedTransactions(transactionsDetails);
        } else {
            setSelectedTransactions([]);
        }

        // For hiding the delete button of first row if there is only one row is available
        const deleteButtons = document.querySelectorAll('.table.table-sm tbody tr:first-of-type .btn.json-editor-btn-delete');
        if (deleteButtons && Array.isArray(data.simulation) && data.simulation.length == 1) {
            deleteButtons.forEach(function(button) {
                button.style.display = 'none';
            });
        }

        // For hide the the title
        const elementToDisable = document.querySelectorAll('.card-title');
        if (elementToDisable) {
            elementToDisable.forEach(element => {
                element.style.display = 'none';
            });
        }

        // For styling the buttons in json editor 
        const elements = document.querySelectorAll('.btn-secondary');
        if (elements) {
            elements.forEach(element => {
                element.style.backgroundColor = '#3f4e5c';
                element.style.margin = '0px 5px';
            });
        }

        // For removing the border in table
        const tdElements = document.querySelectorAll('table td');
        if (tdElements) {
            tdElements.forEach(td => {
                td.style.border = 'none';
            });
        }
        const thElements = document.querySelectorAll('table th');
        if (thElements) {
            thElements.forEach(th => {
                th.style.border = 'none';
            });
        }

        // For adding new row when transaction is selecting
        const  isSelectIncluded = data.simulation?.find(item => item.transaction === 'select');
        if (isSelectIncluded == undefined) {
            setSchemaValues({simulation: [...data.simulation, { transaction: "select", description:" " }]});
        }
    }

    const onTransactionUpdate = () => {
        if (selectedTransactions.length < 1) {
            const validateError = document.getElementById("transaction-validation-error");
            if (validateError === null) {
              document.getElementById(`simulation[simulation][0][transaction]`)?.insertAdjacentHTML("afterend", `<p id="transaction-validation-error" class="text text-danger validation-error" >Please select transaction</p>`);
            }
            return;
        } else {
            const validateError = document.getElementById("transaction-validation-error");
            if (validateError) {
              validateError.remove();
            }
            dispatch(invokePostService('updateTestcaseTransactions', {transactions: selectedTransactions, testsuiteId: entityId}, [testcaseId]))
            .then((response) => {
                if(response.status && response.data){

                    if(response?.data?.testcase != undefined){
                        const delegates = response?.data?.testcase?.delegates?.map(item => ({_id: item?.id}))
                        if(delegates) setSelectedDelegates(delegates)
                    }

                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
                    dispatch(setReRender())
                }
            })
        }   
    }

    return (
        <div>
            {isFetching ?
                <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '28vh' }} />
                :
                <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="json_table_editor"/>
            }
            <Grid xs={12} style={{ justifyContent: 'flex-end', display: 'flex' }}>
              {type === "edit" &&
                <UpdateCancel onUpdate={onTransactionUpdate} onCancel={onClose} updateDisable={isFetching} />
              }
            </Grid>
        </div>
    )
}